class ChatUploadDocument {

    constructor() {

        this.chooseFileFragment = null;
        this.uploadProgressFragment = null;
        this.sendUploadedDocumentFragment = null;

        this.loadPartialsTemplates();

    }

    loadPartialsTemplates() {

        Handlebars.registerPartial('chatUploadDocumentFragment', $('#chatUploadDocumentFragment').html());
        this.chooseFileFragment = Handlebars.compile($('#chatUploadDocumentChooseFileFragment').html());
        this.uploadProgressFragment = Handlebars.compile($('#chatUploadDocumentProgressFragment').html());
        this.sendUploadedDocumentFragment = Handlebars.compile($('#chatUploadDocumentSendFragment').html());

    }

    initUploadSection() {

        let modal = $('#uploadGroupId');
        let modalBody = $('.uploadGroupScrollable');
        let modalBackground = $('#uploadModalBackgroundId');
        let modalCloseIconArea = $('#uploadShowButtonId');
        let modalCloseIconCanvas = $('#uploadShowButtonCanvasId');
        let modalUploadIconArea = $('#cloudUploadAreaId');
        let modalUploadIconCanvas = $('#cloud-icon-canvas-id');
        let modalPosition = $('.uploadGroup.chat-upload-document');

        tintImage(modalCloseIconCanvas.attr('id'), modalCloseIconCanvas.attr('data-icon'), world.theme.color_1);
        tintImage(modalUploadIconCanvas.attr('id'), modalUploadIconCanvas.attr('data-icon'), world.theme.color_1);

        modalCloseIconArea.css('border', '2px solid #' + world.theme.color_1);
        modalUploadIconArea.css('border', '5px solid #' + world.theme.color_1);
        modalPosition.css('bottom', '0px');

        this.loadChooseFileFragment();

        $(document).off('click.closeUploadDocumentModal').on('click.closeUploadDocumentModal', '#uploadShowButtonId', function() {
            modalBackground.hide();
            modal.animate({height: '0px'}, function() {
                modalPosition.css('bottom', '-55px');
            });
        });

        modalBackground.show();
        modal.animate({height: '97%'});

    }

    // Fragment Templates Loaders ================================================== //

    loadChooseFileFragment() {

        let modalBody = $('.uploadGroupScrollable');
        let modalHeaderTitle = $('.uploadGroupTitle');

        modalBody.find('div').remove();
        modalBody.append(this.chooseFileFragment);

        modalHeaderTitle.text(Translator.trans('TR_SELECCIONA_CONTENIDO'));

        let modalBodyChooseFileTable = $('#tableUploadDocId');
        let modalBodyTableOptions = $('.tableLink');
        let modalBodyTableIcons = $('#tableUploadDocId').find('canvas');

        modalBodyChooseFileTable.css('border', '1px solid #' + world.theme.color_1);

        modalBodyTableOptions.each(function() {
            $(this).css('border-top', '1px solid #' + world.theme.color_1);
        });

        modalBodyTableIcons.each(function() {
            tintImage($(this).attr('id'), $(this).attr('data-icon'), world.theme.color_1);
        });

        this.chooseFileFragmentManager();

    }

    loadUploadProgressFragment() {

        let modalBody = $('.uploadGroupScrollable');

        modalBody.find('div').remove();
        modalBody.append(this.uploadProgressFragment);

    }

    loadSendUploadedDocumentFragment(result) {

        let modalBody = $('.uploadGroupScrollable');
        let fragmentData = null;

        if (chatScreenController.room.type === chatScreenController.INDIVIDUAL_ROOM) {
            fragmentData = chatScreenController.room.user.username;
        }

        if (chatScreenController.room.type === chatScreenController.SUPPORT_ROOM) {
            fragmentData = world.theme.support_name;
        }

        if (chatScreenController.room.type === chatScreenController.GROUP_ROOM || chatScreenController.room.type === chatScreenController.CANAL_ROOM) {
            fragmentData = chatScreenController.room.title;
        }

        modalBody.find('div').remove();
        modalBody.append(this.sendUploadedDocumentFragment({username: fragmentData}));

        this.sendUploadedDocumentFragmentManager(result);

    }

    // Fragment Templates Managers ================================================== //

    chooseFileFragmentManager() {

        let that = this;

        let documentType = null;
        let inputFileField = null;

        let uploadedFile = null;
        let uploadedFileType = null;
        let uploadedFileExtension = null;
        let uploadedFileName = null;

        let modalWindow = $(window);

        $(document).off('click.tableFileOption').on('click.tableFileOption', '.tableLink', function() {

            documentType = $(this).data('type');
            inputFileField = $('#' + documentType);
            inputFileField.trigger('click');

            $(document).off('change.selectedFile').on('change.selectedFile', '#' + documentType, function(event) {

                uploadedFile = $(this)[0].files[0];
                uploadedFileType = uploadedFile.type.split('/')[0];
                uploadedFileExtension = $(this).val().replace(/^.*\./, '');
                uploadedFileName = uploadedFile.name;

                if (uploadedFileType === 'image') {

                    imageEditionManager(uploadedFile, uploadedFileExtension, event);

                } else {

                    that.loadUploadProgressFragment();
                    api.uploadChatDocument(uploadedFile, uploadedFileExtension, uploadedFileName, null, that.uploadProgressFragmentManager, that.loadSendUploadedDocumentFragment.bind(that));

                }

            });

        });

        function imageEditionManager(uploadedFile, uploadedFileExtension, event) {

            let reader = new FileReader();
            let modalImageEdition = $('#modalContainer');
            let editedImageSerialized = null;
            let editedImageBase64Format = null;
            let editedImageBlobFormat = null;

            reader.onload = function (event) { startImageEdition(event.target.result) }
            reader.readAsDataURL(uploadedFile);

            $(document).off('click.cancelImageEdition').on('click.cancelImageEdition', '.closeModalImage.chat-upload-document', function() {

                inputFileField.val('');
                modalImageEdition.modal('hide').empty();
                modalWindow.unbind('resize.resizeEditor')

            });

            $(document).off('click.confirmImageEdition').on('click.confirmImageEdition', '.confirmModalImage.chat-upload-document', function() {

                editedImageSerialized = serializeEditedImg();
                editedImageBase64Format = editedImageSerialized.match(/,(.*)$/)[1];
                editedImageBlobFormat = b64toBlob(editedImageBase64Format, editedImageSerialized.split(";")[0].split(":")[1]);

                modalImageEdition.modal('hide').empty();
                modalWindow.unbind("resize.resizeEditor");

                that.loadUploadProgressFragment();
                api.uploadChatDocument(editedImageBlobFormat, uploadedFileExtension, uploadedFile.name, null, that.uploadProgressFragmentManager, that.loadSendUploadedDocumentFragment.bind(that))

            });

        }

    }

    uploadProgressFragmentManager(progressEvent) {

        let textPercentage = $(".uploadBackgroundBar h1");
        let barPercentage = $(".whiteUploadBar");
        let modalHeaderTitle = $(".uploadGroupTitle");

        if (progressEvent.lengthComputable) {

            let percentage = Math.floor(progressEvent.loaded / progressEvent.total * 100);

            textPercentage.text(percentage + "%");
            barPercentage.css('height', 100-percentage + "%");

            if(percentage === 100) {
                modalHeaderTitle.text(Translator.trans('TR_PROCESANDO_ARCHIVO'));
            }

        }

    }

    sendUploadedDocumentFragmentManager(uploadedDocumentResponse) {

        let modal = $('#uploadGroupId');
        let modalBackground = $('#uploadModalBackgroundId');
        let modalHeaderTitle = $(".uploadGroupTitle");
        let modalPosition = $('.uploadGroup.chat-upload-document');

        let messagePayload = uploadedDocumentResponse.result.id;
        let messageType = chatScreenController.USER_DOCUMENT_TYPE;
        let messageRoomId = chatScreenController.room.id;
        let messageUserId = chatScreenController.room.user ? chatScreenController.room.user.user_world_id : null;
        let messageToSupport = chatScreenController.room.type === chatScreenController.SUPPORT_ROOM;

        modalHeaderTitle.text(' ');

        $(document).off('click.cancelUploadDocument').on('click.cancelUploadDocument', '#complete-upload-reject', function() {
            modalBackground.hide();
            modal.animate({height: '0px'}, function() {
                modalPosition.css('bottom', '-55px');
            });
        });

        $(document).off('click.confirmUploadDocument').on('click.confirmUploadDocument', '#complete-upload-accept', function() {

            modalBackground.hide();
            modal.animate({height: '0px'}, function() {
                modalPosition.css('bottom', '-55px');
            });

            socketRequest.sendMessage(messagePayload, messageType, messageRoomId, messageUserId, messageToSupport);

        });

    }

}

